import { Typography, Button } from "@mui/material";
import { Capacitor } from "@capacitor/core";
import TaskUsage from "../../account/TaskUsage";
import useSubscribe from "../../../hooks/subscription/useSubscribe";

const PlsSubscribePanel = ({ next }) => {
  const { subscribe, subscribing } = useSubscribe({ onSuccess: next, onCancel: next });

  const handleClick = () => {
    // On web, close the overlay before navigating to /subscribe
    if (!Capacitor.isNativePlatform()) {
      next();
    }
    // On mobile, onSuccess/onCancel callbacks handle closing
    subscribe();
  };

  return (
    <div className="pls-subscribe-panel">
      <Typography variant="h2">Need more tasks?</Typography>
      <div>
        <div className="pls-subscribe-panel_usage-container">
          <TaskUsage hideSubscribeButton={true} />
        </div>
      </div>

      <Typography variant="p1">
        The free version of Mindstack lets you have up to 10 active tasks.
      </Typography>
      <Typography variant="p1">
        If you plan to use Mindstack long term, perhaps you'd consider
        supporting us?
      </Typography>

      <Button
        variant="contained"
        className="pls-subscribe-panel_subscribe-button"
        disabled={subscribing}
        onClick={handleClick}
      >
        <span
          style={{
            color: "#FFFFFF",
            textTransform: "none",
          }}
        >
          {subscribing ? "Subscribing…" : "Subscribe to Mindstack"}
        </span>
      </Button>
    </div>
  );
};

export default PlsSubscribePanel;
